(function () {
    'use strict';

    angular
        .module('app.campaignActivity')
        .directive('campaignSlider', function ($rootScope, $stateParams, campaignActivityService) {
            //console.log($rootScope.currentUser);
            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    currentStatus: '='
                },
                transclude: true,
                template: '<input type="text" />',
                link: function ($scope, element, attrs) {
                    var slider = $(element[0]).bootstrapSlider({
                            ticks: [0, 1, 2, 3],
                            ticks_positions: [0, 33, 66, 100],
                            formatter: function(value) {
                                var rs = campaignActivityService.campaignStatuses.find(function (item) {
                                    return item.value == (value + 1)
                                });

                                function capitalizeFirstLetter (string) {
                                    string = string.toLowerCase();
                                    return string.charAt(0).toUpperCase() + string.slice(1);
                                };

                                return 'Select status: ' + capitalizeFirstLetter(rs.name);
                            },
                            ticks_tooltip: true,
                    });

                    $scope.$watch('currentStatus', function(newValue, oldValue) {
                        if (newValue && oldValue !== newValue) {
                            $("#pipeLineStatus").bootstrapSlider('setValue', (newValue.value - 1));
                        }
                    }, true);

                    if ($rootScope.currentUser.role.accessLevel === 'influencer') {
                        $("#pipeLineStatus").bootstrapSlider('disable');
                    }

                    slider.on('slideStop', function (ev) {
                        $("#pipeLineStatus").bootstrapSlider('setValue', ev.value);
                        var previousStatus = $scope.currentStatus;

                        $scope.currentStatus = campaignActivityService.campaignStatuses.find(function (item) {
                            return item.value == (ev.value + 1)
                        });

                        if (previousStatus.value != $scope.currentStatus.value){
                            var params = {
                                id: $stateParams.campaign_influencer_id,
                                status: $scope.currentStatus.name,
                                accessLevel: $rootScope.currentUser.role.accessLevel
                            };

                            campaignActivityService.changeCampaignInfluencerStatus(params, null)
                                .then(function(response) {
                                    $rootScope.$broadcast('reloadActivities');
                                }, function(errResponse) {
                                    $scope.currentStatus = previousStatus;
                                    $rootScope.handleRequestError(errResponse, $scope);
                                });

                            $scope.$apply();
                        }
                    });
                }
            }
        });
})();
